{
    "features-debit-card-atms": {
        "meta": {
            "title": "Retira efectivo en nuestros ATMs sin cargos extra - MAJORITY",
            "description": "No pagues ningún cargo para retirar efectivo en cualquiera de nuestros más de 55,000 ATMs. Obtén más información y encuentra un cajero automático cerca de ti."
        },
        "hero": {
            "title": "Ahorra en ATMs sin cargos extras",
            "body": "Ofrecemos acceso a más de 55,000 ATMs sin cargos.",
            "cta": "Comenzar"
        },
        "no_fees_content_box": {
            "tagline": "TARJETA** DE DÉBITO VISA®",
            "title": "Deja de pagar cargos en ATMs",
            "body": "Es tu dinero. Entonces, ¿por qué deberías pagar cargos para retirar tu propio efectivo? Ahora ya no lo tienes que hacer cuando utilices un cajero automático dentro de nuestra red de más de 55,000 cajeros automáticos. En promedio, puedes ahorrar entre $2 y $5 cada vez que retires dinero.",
            "cta": "Comenzar",
            "canvas": "Más de 55,000 ATMs sin cargos extra"
        },
        "free_withdraw_content_box": {
            "tagline": "TARJETA** DE DÉBITO VISA®",
            "title": "Cómo hacer retiros en un ATM gratis",
            "body": "Evita pagar cargos innecesarios cuando utilices tu tarjeta de débito MAJORITY Visa® para realizar retiros de efectivo en ATMs gratis cerca de ti. Con más de 55,000 cajeros automáticos podrás encontrar fácilmente un cajero automático cerca de ti porque cuentas con una gran cobertura en todo el país.",
            "cta": "Comenzar"
        },
        "surcharge_free_content_box": {
            "tagline": "TARJETA** DE DÉBITO VISA®",
            "title": "Encuentra un ATM sin cargos cerca de ti",
            "body": "¿Necesitas encontrar un ATM o cajero automático cerca de ti? Puedes consultar nuestro mapa de cajeros automáticos en la app. Con tantos ATMs dentro de la red en todo el país, siempre podrás encontrar uno cerca de ti."
        }
    }
    
}